import { theme, ifProp, prop, withProp } from 'styled-tools';
import styled, { css } from './styled.js';
import as from './as.js';
import Box from './Box.js';
import PropTypes__default from 'prop-types';
import 'styled-components';
import './chunk-fb907809.js';
import '@emotion/is-prop-valid';
import 'react';
import 'hoist-non-react-statics';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';

var GroupItem = styled(Box).withConfig({
  displayName: "GroupItem",
  componentId: "kbprqg-0"
})(["", ";"], theme("GroupItem"));
var GroupItem$1 = as("div")(GroupItem);

var verticalAt = function verticalAt(pass, fail) {
  return ifProp("verticalAt", css(["@media (min-width:", "px){", ";}@media (max-width:", "px){", ";}"], withProp("verticalAt", function (x) {
    return x + 1;
  }), fail, prop("verticalAt"), pass), fail);
};

var Group = styled(Box).withConfig({
  displayName: "Group",
  componentId: "ope6r0-0"
})(["display:flex;flex-direction:", ";", ";> *:not(:first-child):not(:last-child),> *:not(:first-child):not(:last-child) ", "{border-radius:0;", ";}> *:first-child,> *:first-child ", "{border-bottom-right-radius:0;", ";}> *:last-child,> *:last-child ", "{border-top-left-radius:0;", ";}", ";"], ifProp("vertical", "column", "row"), verticalAt("flex-direction: column"), GroupItem$1, verticalAt(css(["border-top-width:0;"]), css(["border-", "-width:0;"], ifProp("vertical", "top", "left"))), GroupItem$1, verticalAt(css(["border-bottom-left-radius:0;"]), css(["border-", "-radius:0;"], ifProp("vertical", "bottom-left", "top-right"))), GroupItem$1, verticalAt(css(["border-top-width:0;border-top-right-radius:0;"]), css(["border-", "-width:0;border-", "-radius:0;"], ifProp("vertical", "top", "left"), ifProp("vertical", "top-right", "bottom-left"))), theme("Group"));
Group.propTypes = {
  vertical: PropTypes__default.bool,
  verticalAt: PropTypes__default.number
};
Group.defaultProps = {
  role: "group"
};
var Group$1 = as("div")(Group);

Group$1.Item = GroupItem$1;

export default Group$1;
